import { FC, useEffect } from "react";
import OutsideClickHandler from "../OutsideClickHandler/OutsideClickHandler";

import { ModalProps } from "./types";
import { CrossIcon } from "../icons/CrossIcon";

import styles from "./Modal.module.css";



const Modal: FC<ModalProps> = ({ isOpen, onClose, children }) => {
  useEffect(() => {
    const handleEscKeyPress = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscKeyPress);
    }

    return () => {
      document.removeEventListener('keydown', handleEscKeyPress);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className={styles.modal}>
      <OutsideClickHandler onOutsideClick={onClose}>
        <div className={styles.modal__box}>
          <button className={styles.modal__close} onClick={onClose}>
            <CrossIcon />
          </button>
          {children}
        </div>
      </OutsideClickHandler>
    </div>
  );
};

export default Modal; 